import { render } from "./realNamePage.vue?vue&type=template&id=6c878e85"
import script from "./realNamePage.vue?vue&type=script&lang=js"
export * from "./realNamePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_269ca4a85a7eca3d5d7c9cc630d4bd5a/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__